import { useState } from 'react';
import classNames from 'classnames';
import { t } from 'ttag';

import { usePromotionPayment } from '@hook/usePromotionPayment';
import { Title } from '@ui/Title';
import { PromotionPackage, PromotionPackageCard } from '@components/PromotionPackageCard';
import { Promotion, PromotionCard, PromotionTariff } from '@components/PromotionCard';

import s from './ProductDetailsPromotionServices.sss';

interface Props {
  className?: string,
  productId: number,
  promotionPackages?: PromotionPackage[] | null,
  promotions: Promotion[],
  next: string,
  referrer: string,
}

export const ProductDetailsPromotionServices: React.FC<Props> = ({
  className,
  productId,
  promotionPackages,
  promotions,
  next,
  referrer,
}) => {
  const [expandedService, setExpandedService] = useState<PromotionPackage | Promotion | null>(
    promotionPackages?.find((promotionPackage) => promotionPackage.isOpenedByDefault) || null,
  );

  const {
    isDisabled,
    handleSelectPromotion,
    handleSelectPromotionPackage,
  } = usePromotionPayment(productId);

  const handleExpand = (service: PromotionPackage | Promotion) => {
    setExpandedService(
      (prevState) => (prevState === service ? null : service),
    );
  };

  const handlePackageSelect = (promotionPackage: PromotionPackage) => {
    handleSelectPromotionPackage({
      promotionPackage,
      next,
      referrer,
    });
  };

  const handlePromotionSelect = (tariff: PromotionTariff) => {
    handleSelectPromotion({
      tariff,
      next,
      referrer,
    });
  };

  return (
    (
      <div className={classNames(s.root, className)}>
        <Title
          className={s.title}
          type="h3"
          bold={false}
        >
          {t`Просування оголошення`}
        </Title>
        <p className={s.description}>
          {t`Виберіть один із пакетів реклами для швидкого продажу речей`}
        </p>
        <ul className={s.list}>
          {promotionPackages?.map((promotionPackage) => (
            <li
              key={promotionPackage.id}
              className={s.item}
            >
              <PromotionPackageCard
                theme="details"
                promotionPackage={promotionPackage}
                isDisabled={isDisabled}
                isExpand={expandedService === promotionPackage}
                isActive={expandedService === promotionPackage}
                onSubmit={handlePackageSelect}
                onExpand={() => handleExpand(promotionPackage)}
              />
            </li>
          ))}
          {promotions.map((promotion) => (
            <li
              key={promotion.title}
              className={s.item}
            >
              <PromotionCard
                theme="details"
                promotion={promotion}
                isDisabled={isDisabled}
                isExpand={expandedService === promotion}
                isActive={expandedService === promotion}
                onSubmit={handlePromotionSelect}
                onExpand={() => handleExpand(promotion)}
              />
            </li>
          ))}
        </ul>
      </div>
    )
  );
};
